import { render, staticRenderFns } from "./PharmacistProfile.vue?vue&type=template&id=80805954&scoped=true&"
import script from "./PharmacistProfile.vue?vue&type=script&lang=ts&"
export * from "./PharmacistProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistProfile.vue?vue&type=style&index=0&id=80805954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80805954",
  null
  
)

export default component.exports